import { useSearchParams } from "react-router-dom";
import styles from "../../../styles/Components/new-insight/chart-section/OverallInsights.module.css";
import { FaChartLine } from "react-icons/fa6";
import { useSelector } from "react-redux";
import useFetchLiveSignal from "../../../hooks/api/useFetchLiveSignal";
import { Skeleton } from "antd";
import useServiceStatus from "../../../hooks/useServiceStatus";
import PlaceOrderButton from "../signals-section/PlaceOrderButton";
import useInsightOverallSignal from "../../../hooks/useInsightOverallSignal";
import InsightsSignalCard from "./InsightsSignalCard";
import InsightsLiveSignalCard from "./InsightsLiveSignalCard";

function OverallInsights() {
  const {
    liveSuggestion: { suggestions, coinStatus },
    newInsightState: { signalData, signalTableColumns, signalStatus },
  } = useSelector((state) => state);

  const [searchParams] = useSearchParams();
  const symbol = searchParams.get("symbol") || "BTC";

  const { isActive: isInsightActive } = useServiceStatus("insight");
  const { isActive: isAiActive } = useServiceStatus("aiAssistant");

  const isActive = isInsightActive;

  const isLiveSignalLoading = coinStatus?.[symbol] === "loading";

  const liveSignal = suggestions?.find((s) => s.symbol === symbol);

  // useFetchLiveSignal({ coins: [symbol] });

  const { signalConfidence, finalSuggestion } = useInsightOverallSignal(symbol);

  const signalSources = signalTableColumns?.filter(
    (c) => c !== "coin" && c !== "Signals",
  );
  const insightSignal = signalData?.find((s) => s?.coin === symbol);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <FaChartLine color="#0C4CFC" size={18} />
        <h3>{symbol}/USDT Insights</h3>
      </div>

      <div className={styles.overallBox}>
        <span className={styles.overallBoxTitle}>Overall Signal</span>

        {isLiveSignalLoading || signalStatus === "loading" ? (
          <Skeleton.Node className={styles.overallLoader} active />
        ) : !finalSuggestion || !isActive ? (
          <span>-</span>
        ) : (
          <div className={styles.suggestedSignal}>
            <PlaceOrderButton coin={symbol} />
            {!!signalConfidence && (
              <span className={styles.confidence}>
                {Number(signalConfidence)?.toFixed(2)}% Confidence
              </span>
            )}
          </div>
        )}
      </div>

      <div className={styles.signalsList}>
        <InsightsLiveSignalCard
          data={liveSignal}
          loading={isLiveSignalLoading}
        />

        {signalStatus === "loading"
          ? Array.from({ length: 3 })?.map((_, i) => (
              <Skeleton.Node className={styles.signalLoader} key={i} active />
            ))
          : signalSources.map((s) => (
              <InsightsSignalCard
                key={s}
                data={insightSignal?.[s]}
                title={s?.split("-")?.[0]}
              />
            ))}
      </div>
    </div>
  );
}

export default OverallInsights;
